<template>
  <div
    class="right_swiper_wrapper_m animated"
    v-if="options.isAni"
    :class="{ fadeInUp: options.isAni }"
  >
    <div class="swiper_m">
      <swiper
        :options="swiperOption"
        class="mySwiper"
        style="position: absolute; top: 0; left: 0; bottom: 0; right: 0"
        v-if="swiperList.length"
      >
        <swiper-slide v-for="(item, index) in swiperList" :key="index">
          <a :href="item.jump_link" target="_blank">
            <img :src="item.file.file_path" width="100%" />
          </a>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeSwiper",
  props: {
    swiperList: Array,
  },
  data() {
    return {
      options: {
        isAni: false,
      },
      swiperOption: {
        pagination: ".right_swiper_wrapper_m .swiper-pagination",
        paginationClickable: true,
        grabCursor: true,
        loop: true,
        initialSlide: 0,
        autoplay: 500000,
        autoplayDisableOnInteraction: false,
        coverflow: {
          rotate: 30,
          stretch: 10,
          depth: 60,
          modifier: 2,
          slideShadows: true,
        },

        observeParents: true,
      },
    };
  },
  methods: {},
  mounted() {
    this.isLoading = false;
    this.options.isAni = true;
  },
};
</script>

<style lang="stylus" scoped>
.right_swiper_wrapper_m {
  width: 100%;

  .swiper_m >>> .swiper-container {
    z-index: 0 !important;
  }

  .swiper_m >>> .swiper-pagination-bullet-active {
    background: #fcc916 !important;
  }

  .swiper_m >>> .swiper-pagination-bullet {
    width: 0.325rem;
    height: 0.325rem;
    opacity: 1;
    margin-left: 10px !important;
    box-sizing: border-box;
    border-radius: 100%;
    border: 1px solid #fcc916;
    background: none;
    cursor: pointer;
  }

  .swiper_m >>> .swiper-pagination-bullets {
    width: 100%;
    bottom: 5px !important;
  }

  .swiper_m {
    position: relative;
    z-index: 0;
    width: 95%;
    margin 0 auto;
    height: 3.47rem;
    border-radius: 0.2rem;

    .swiper-container {
      width: 100%;

      .swiper-slide {
        a {
          display block;
          width: 100%;
          height: 100%;
          position: relative;
          overflow: hidden;

          img {
            display: block
            border-radius: 0.15rem;
          }
        }
      }
    }
  }
}
</style>
